import React from 'react';
const problems = ['Arrivi in palestra senza un piano preciso', 'Passi ore a preparare gli allenamenti', 'Cerchi continuamente nuovi esercizi online', 'Hai gruppi con livelli molto diversi', 'I giocatori migliorano lentamente', 'Le famiglie chiedono risultati concreti', 'Quando mancano giocatori devi improvvisare', 'Ti senti sempre in ritardo con la programmazione'];
export function ProblemSection() {
  return <section className="w-full bg-white py-16 px-4" data-id="element-178">
      <div className="max-w-3xl mx-auto text-center" data-id="element-179">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-[#0A0A0A] mb-10 tracking-tight leading-tight" data-id="element-180">
          Se alleni basket, probabilmente stai vivendo almeno uno di questi
          problemi:
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-left mb-12" data-id="element-181">
          {problems.map((problem, i) => <div key={i} className="flex items-start gap-3 bg-[#FAFAFA] border border-[#E5E5EA] rounded-2xl p-4 shadow-sm" data-id="element-182">
              <span className="text-red-500 text-xl flex-shrink-0" data-id="element-183">❌</span>
              <p className="text-[#0A0A0A] text-sm sm:text-base font-semibold leading-snug" data-id="element-184">
                {problem}
              </p>
            </div>)}
        </div>

        <p className="text-[#FF6B00] text-2xl sm:text-4xl font-black mb-8 tracking-tight" data-id="element-185">
          Quanti allenamenti ancora vuoi improvvisare?
        </p>

        <div className="h-px bg-gradient-to-r from-transparent via-[#E5E5EA] to-transparent w-full" data-id="element-186" />
      </div>
    </section>;
}